import api from './api'

export type WorkerOnboardingPolicy = { requiredSteps: string[]; requiredDocumentTypes: string[] }
export type WorkerOnboardingPolicyState = { success: boolean; tenantId: string; policy: WorkerOnboardingPolicy; revision: number; stepKeys: string[]; documentTypes: string[] }
export async function getWorkerOnboardingPolicy(tenantId: string) {
  return (await api.get<WorkerOnboardingPolicyState>('/api/admin/settings/worker-onboarding', { headers: { 'x-tenant-id': tenantId } })).data
}
export async function saveWorkerOnboardingPolicy(tenantId: string, policy: WorkerOnboardingPolicy, expectedRevision: number) {
  return (await api.put<WorkerOnboardingPolicyState>('/api/admin/settings/worker-onboarding', { policy, expectedRevision }, { headers: { 'x-tenant-id': tenantId } })).data
}
